import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from './slice';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MandateTypeService } from './mandateType.service';

@Injectable()
export class MandateTypeEffects {
  loadMandateTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadMandateTypes),
      switchMap(() =>
        this.mandateTypeService.loadMandateTypes().pipe(
          switchMap((mandateTypes) =>
            of(fromActions.loadMandateTypesSuccess(), fromActions.upsertMandateTypes({ entities: mandateTypes }))
          ),
          catchError(() => of(fromActions.loadMandateTypesFailure()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly mandateTypeService: MandateTypeService
  ) {}
}
